module.exports = __webpack_public_path__ + "static/media/d50774bb2e181f81cdca8cd3d635e4dd_html_f604402edcf41ddd.fb7ad1d4.png";